module.exports = __webpack_public_path__ + "img/icon_map_lsjjr_c.56fe5845.png";